<template>
  <v-container>
    <v-row>
      <v-col cols="9">
        <v-skeleton-loader
          :loading="collectionPointLoading"
          :types="skeleton"
          type="article"
          class="mb-6"
          height="266"
        >
          <CollectionPointHeaderCard
            :title="
              collectionPoint
                ? `Odběrné místo ${collectionPoint.voltageLevel}`
                : ''
            "
            detailType="collectionPoint"
            :data="collectionPoint"
          />
        </v-skeleton-loader>

        <v-skeleton-loader
          v-if="collectionPoint.voltageLevel === 'NN'"
          :loading="collectionPointLoading"
          :types="skeleton"
          type="article"
          class="mb-6"
          height="266"
        >
          <v-card class="elevation-12">
            <v-card-title class="px-9 pt-7">
              Technické informace
            </v-card-title>

            <v-card-text class="px-9">
              <v-row>
                <v-col>
                  <v-row>
                    <v-col>Druh odběrného místa:</v-col>

                    <v-col class="text-right font-weight-bold" cols="auto">
                      {{ collectionPoint.networkDelivery ?
                      collectionPoint.networkDelivery.localizedText : '' }}
                    </v-col>
                  </v-row>

                  <v-row>
                    <v-col>Napěťová hladina:</v-col>

                    <v-col class="text-right font-weight-bold" cols="auto">
                      {{ collectionPoint.voltageLevel }}
                    </v-col>
                  </v-row>

                  <v-row>
                    <v-col>Typ měření:</v-col>

                    <v-col class="text-right font-weight-bold" cols="auto">
                      {{ collectionPoint.measureType }}
                    </v-col>
                  </v-row>

                  <v-row>
                    <v-col>Kategorie měření:</v-col>

                    <v-col class="text-right font-weight-bold" cols="auto">
                      {{ collectionPoint.measureCategory }}
                    </v-col>
                  </v-row>

                  <v-row>
                    <v-col>Hodnota jističe:</v-col>

                    <v-col class="text-right font-weight-bold" cols="auto">
                      {{ collectionPointFuse }}
                    </v-col>
                  </v-row>
                </v-col>

                <v-divider class="my-1" vertical light></v-divider>

                <v-col>
                  <v-row>
                    <v-col>Distribuční sazba:</v-col>

                    <v-col class="text-right font-weight-bold" cols="auto">
                      {{ collectionPoint.distributionRate }}
                    </v-col>
                  </v-row>

                  <v-row>
                    <v-col>Distribuční sazba od:</v-col>

                    <v-col class="text-right font-weight-bold" cols="auto">
                      {{
                        dateFormatting(collectionPoint.distributionRateUntil)
                      }}
                    </v-col>
                  </v-row>

                  <v-row>
                    <v-col>Číslo elektroměru:</v-col>

                    <v-col class="text-right font-weight-bold" cols="auto">
                      {{ collectionPoint.deviceSerialNumber }}
                    </v-col>
                  </v-row>

                  <v-row>
                    <v-col>Počet fází:</v-col>

                    <v-col class="text-right font-weight-bold" cols="auto">
                      {{ collectionPoint.fase }}
                    </v-col>
                  </v-row>

                  <v-row>
                    <v-col>Umístění měření:</v-col>

                    <v-col class="text-right font-weight-bold" cols="auto">
                      {{ collectionPoint.measureLocation
                        ? collectionPoint.measureLocation.localizedText
                        : '' }}
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-skeleton-loader>

        <v-skeleton-loader
          v-if="collectionPoint.voltageLevel === 'NN'"
          :loading="collectionPointLoading"
          :types="skeleton"
          type="article"
          class="mb-6"
          height="266"
        >
          <v-card class="elevation-12">
            <v-card-title class="px-9 pt-7">
              Poslední odečet elektroměru
            </v-card-title>

            <v-card-text class="px-9">
              <v-row>
                <v-col>
                  <v-row>
                    <v-col>Datum posledního odečtu:</v-col>

                    <v-col class="text-right font-weight-bold" cols="auto">
                      {{
                        dateFormatting(collectionPoint.lastReadingAt)
                      }}
                    </v-col>
                  </v-row>

                  <v-row>
                    <v-col>Plánovaný měsíc odečtu:</v-col>

                    <v-col class="text-right font-weight-bold" cols="auto">
                      {{
                        dateFormattingSpecial(collectionPoint.lastPlanReadingAt, 'M')
                      }}
                    </v-col>
                  </v-row>
                </v-col>

                <v-divider class="my-1" vertical light></v-divider>

                <v-col>
                  <v-row>
                    <v-col>Poslední stav elektroměru (VT):</v-col>

                    <v-col class="text-right font-weight-bold" cols="auto">
                      {{
                        collectionPoint.lastReadingHighTariff
                          ? collectionPoint.lastReadingHighTariff
                          : '0'
                      }}
                      kWh
                    </v-col>
                  </v-row>

                  <v-row v-if="collectionPoint.distributionRateSingleTariff !== true">
                    <v-col>Poslední stav elektroměru (NT):</v-col>

                    <v-col class="text-right font-weight-bold" cols="auto">
                      {{
                        collectionPoint.lastReadingLowTariff
                          ? collectionPoint.lastReadingLowTariff
                          : '0'
                      }}
                      kWh
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-skeleton-loader>

        <v-skeleton-loader
          v-if="collectionPoint.voltageLevel === 'VN'"
          :loading="collectionPointLoading"
          :types="skeleton"
          type="article"
          class="mb-6"
          height="266"
        >
          <v-card class="elevation-12">
            <v-card-title class="px-9 pt-7">
              Technické informace
            </v-card-title>

            <v-card-text class="px-9">
              <v-row>
                <v-col>
                  <v-row>
                    <v-col>Druh odběrného místa:</v-col>

                    <v-col class="text-right font-weight-bold" cols="auto">
                      {{ collectionPoint.networkDelivery ?
                      collectionPoint.networkDelivery.localizedText : '' }}
                    </v-col>
                  </v-row>

                  <v-row>
                    <v-col>Napěťová hladina:</v-col>

                    <v-col class="text-right font-weight-bold" cols="auto">
                      {{ collectionPoint.voltageLevel }}
                    </v-col>
                  </v-row>

                  <v-row>
                    <v-col>Typ měření:</v-col>

                    <v-col class="text-right font-weight-bold" cols="auto">
                      {{ collectionPoint.measureType }}
                    </v-col>
                  </v-row>

                  <v-row>
                    <v-col>Číslo TS:</v-col>

                    <v-col class="text-right font-weight-bold" cols="auto">
                      {{ collectionPoint.distributionSubstation }}
                    </v-col>
                  </v-row>

                  <v-row>
                    <v-col>Číslo elektroměru:</v-col>

                    <v-col class="text-right font-weight-bold" cols="auto">
                      {{ collectionPoint.deviceSerialNumber }}
                    </v-col>
                  </v-row>
                </v-col>

                <v-divider class="my-1" vertical light></v-divider>

                <v-col>
                  <v-row>
                    <v-col>Rezervovaný příkon:</v-col>

                    <v-col class="text-right font-weight-bold" cols="auto">
                      {{ collectionPoint.reservedPowerInput }} kW
                    </v-col>
                  </v-row>

                  <v-row>
                    <v-col>Regulační stupeň:</v-col>

                    <v-col class="text-right font-weight-bold" cols="auto">
                      {{ collectionPoint.regulationLevel }}
                    </v-col>
                  </v-row>

                  <v-row>
                    <v-col>Bezp. minimum při reg. st. 7:</v-col>

                    <v-col class="text-right font-weight-bold" cols="auto">
                      {{ collectionPoint.regulationLevelSafety7 }} kW
                    </v-col>
                  </v-row>

                  <v-row>
                    <v-col>Umístění měření:</v-col>

                    <v-col class="text-right font-weight-bold" cols="auto">
                      {{ collectionPoint.measureLocation
                        ? collectionPoint.measureLocation.localizedText
                        : '' }}
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-skeleton-loader>

        <v-skeleton-loader
          v-if="collectionPoint.voltageLevel === 'VN'"
          :loading="collectionPointLoading"
          :types="skeleton"
          type="article"
          class="mb-6"
          height="266"
        >
          <CollectionPointReservedCapacity v-model="collectionPoint" />
        </v-skeleton-loader>
      </v-col>

      <CollectionPointRightSideCards
        :collectionPoint="collectionPoint"
        @searchInstallation="searchInstallation"
        @installationLoading="collectionPointLoading = $event"
        :eanErrorMessage="eanErrorMessage"
        :collectionPointLoading="collectionPointLoading"
      />
    </v-row>
  </v-container>
</template>

<script>
import CollectionPointHeaderCard from '@/components/CollectionPointHeaderCard.vue';
import CollectionPointReservedCapacity from '@/components/CollectionPointReservedCapacity.vue';
import { installationMixin } from '@/components/mixins/installationMixin';
import CollectionPointRightSideCards from '@/components/utils/CollectionPointRightSideCards.vue';

export default {
  name: 'CollectionPointDetail',
  mixins: [installationMixin],
  components: {
    CollectionPointHeaderCard,
    CollectionPointReservedCapacity,
    CollectionPointRightSideCards,
  },
  computed: {
    collectionPointFuse() {
      const number = Number(this.collectionPoint.fuse);
      if (number === null) {
        return '';
      }
      let digits = 1;
      if (number === Math.floor(number)) {
        digits = 0;
      }
      return number.toFixed(digits).replace('.', ',');
    },
  },
  created() {
    this.loadInstallation().then((response) => {
      if (response.data.allowedInstallationAction.name === 'NONE_MANUFACTURING_INSTALLATION'
        || response.data.allowedInstallationAction.name === 'NONE_DISTRIBUTION_ONLY_INSTALLATION') {
        this.$router.push({
          name: 'collectionPoint',
          params: {
            ean: this.$route.params.ean,
            eanErrorMessage: response.data.allowedInstallationAction.localizedText,
          },
        });
      }
    });
  },
};
</script>
